var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSlip = function SvgSlip(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1319 26.8398C9.91651 26.8819 9.69754 26.9032 9.47803 26.9035H10.1319V26.8398Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1335 26.8982H22.911C22.2515 26.8755 21.6272 26.5947 21.1726 26.1163C20.718 25.6378 20.4695 25 20.4805 24.3401V19.1662C20.4805 19.1049 20.4683 19.0442 20.4447 18.9876C20.4211 18.9311 20.3865 18.8798 20.3429 18.8367C20.2993 18.7936 20.2475 18.7597 20.1907 18.7367C20.1339 18.7138 20.073 18.7024 20.0118 18.7032H6.47039C6.40986 18.7032 6.34994 18.7152 6.29409 18.7385C6.23824 18.7618 6.18759 18.796 6.14506 18.8391C6.10253 18.8822 6.06898 18.9333 6.04634 18.9894C6.02371 19.0456 6.01245 19.1056 6.01322 19.1662V23.4257C6.01322 24.3467 6.37903 25.2299 7.03019 25.8811C7.68134 26.5323 8.5645 26.8982 9.48537 26.8982H10.1335Z",
    stroke: "#575757",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1333 18.7035V14.8086",
    stroke: "#575757",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1333 4.79081V2.99671C10.1331 2.8481 10.1901 2.70512 10.2924 2.59738C10.3948 2.48964 10.5346 2.4254 10.6831 2.41797H25.8448C25.9982 2.41797 26.1454 2.47894 26.254 2.58748C26.3625 2.69601 26.4235 2.84322 26.4235 2.99671V23.4263C26.4235 24.3473 26.0576 25.2305 25.4065 25.8817C24.7553 26.5329 23.8722 26.8988 22.9513 26.8988V26.8988C22.2918 26.8761 21.6675 26.5953 21.2129 26.1169C20.7583 25.6385 20.5098 25.0006 20.5208 24.3407",
    stroke: "#575757",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Slip.fa599cfb.svg";
export { ForwardRef as ReactComponent };